import {BankType} from "../../../home/bank/model/BankType";
import {ApprovalState} from "../../../home/memo/model/ApprovalState";

export class ApprovableBankTypeRequestWithRecipientId {
  id:                     number;
  employeeCode:           string;
  refDate:                Date;
  valueInMinutes:         number;
  completeDay:            boolean;
  bankTypeId:             number;
  scheduleId:             number;
  approvalState =         ApprovalState.APPROVED;
  requesterNote:          string;
  requesterFullName:      string;
  approverNote:           string;
  recipientId: string;

    bank = new BankType();

  _createSpecialElement(propertyName: string, data: any) {
   if ('approvalState' === propertyName) {
     this.approvalState = ApprovalState.retrieveFromCode(data);
     return true;
   }

   return false;
  }

/*
_createFromArray(propertyName: string, data: any) {
 const serializer = new JSonSerializer();
 if ('schedules' === propertyName) {
  for (const bean of <EmployeHoraire[]> data) {
   const tmp = new EmployeHoraire();
   serializer.deserialize(bean, tmp);
   this.schedules.push(tmp);
  }
 }
}

 */


}
